module.exports = __webpack_public_path__ + "img/electricCar-grey.e2389066.svg";